type EventTypes = 'virtual' | 'in-person'

export interface EventItem {
  id: string
  date: Date
  title: string
  location: string
  description: string
  type: EventTypes
}

export const EVENTS: EventItem[] = []

// const mockEvents: EventItem[] = [
//   {
//     id: '0',
//     date: {
//       day: 21,
//       month: 9,
//       year: 2026,
//       time: "11:00 AM",
//     },
//     title: 'The Solstice Soiree',
//     location: 'My house', 
//     description: 'When the stars align, we gather. Join us for live recordings, virtual brunch, and local meetups.',
//     type: 'in-person'
//   },
//   {
//     id: '1',
//     date: {
//       day: 14,
//       month: 10,
//       year: 2026,
//       time: '2:00 PM'
//     },
//     title: 'Live: The Myth of Persephone',
//     location: 'Virtual Studio Access',
//     description: '',
//     type: 'virtual',
//   },
//   {
//     id: '2',
//     date: {
//       day: 28,
//       month: 10,
//       year: 2026,
//       time: '10:30 AM'
//     },
//     title: "Mimosa Masterclass: Hecate's Brew",
//     location: 'Community Kitchen',
//     description: '',
//     type: 'virtual',
//   },
//   {
//     id: '3',
//     date: {
//       day: 5,
//       month: 11,
//       year: 2026,
//       time: '6:00 PM'
//     },
//     title: 'Moms & Manifestations Workshop',
//     location: 'NYC In-Person Gathering',
//     description: '',
//     type: 'in-person',
//   },
// ];
